import React, {Component} from 'react'
import {Input} from "antd"
import 'antd/lib/input/style/index.css'
import PropTypes from 'prop-types'

class FilterDetailError extends Component {
    _handleChange = (e) => {
        const {name, value} = e.target
        const {onChangeFilters} = this.props
        const filters = Object.assign({}, this.props.filters)

        if (typeof onChangeFilters === 'function') {
            onChangeFilters({
                ...filters,
                [name]: value
            })
        }
    }

    render() {
        const {filters} = this.props
        const {detailError} = filters

        return (
            <div className="FilterOrderNumber mb-3 mr-3">
                <label className='font-weight-bold d-block'>Chi tiết lỗi</label>
                <Input name="detailError" value={detailError} onChange={this._handleChange} placeholder='Tìm kiếm chi tiết lỗi' style={{width: 350}}/>
            </div>
        )
    }
}

FilterDetailError.propTypes = {
    filters: PropTypes.object.isRequired,
    onChangeFilters: PropTypes.func.isRequired
}

export default FilterDetailError